<div class="mat-body text-center">
    <button type="button" class="btn-close mat-elevation-z0" mat-icon-button (click)="onClose()" *ngIf="!dialogRef.disableClose">
        <mat-icon>close</mat-icon>
    </button>
    <div class="mat-headline my-3 my-md-5">
        <i class="icon-exclamation red-icon-exclamation mb-3" *ngIf="type !== 'info'"></i>
        <i class="icon-exclamation blue-icon-exclamation mb-3" *ngIf="type === 'info'"></i>
        <p class="mb-0" [innerHTML]="errorMsg|translate:errorMsgParams"></p>
    </div>
</div>
